import { useRepoContexts } from './useRepoContexts'

export function useIsS3Task(): boolean {
  const repoContexts = useRepoContexts()
  return repoContexts.some(ctx => ctx.connType === 'S3')
}
